
            const data = {"name":"expand-open","data":{"width":"16","height":"16","viewBox":"0 0 16 16","data":"<path pid=\"0\" d=\"M9.107 3h3.89m0 0v3.889m0-3.889L6.998 9m-.003 4h-4m0 0V9m0 4 4-4\" _stroke=\"#81889B\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>","originalColors":[{"type":"stroke","color":"#81889B"}],"stopColors":[]}}
        
                    module.exports = data
                    